import { useEffect, useState } from "react";
import { useInterviewContext } from "../InterviewContext";
import TechnicalSkillsSectionItemContent from "./TechnicalskillSectionItemContent";
import "../../styles/forms.scss";
import { useTranslation } from "react-i18next";

export default function TechnicalSkillsSectionItem({
  index,
  heading,
  technologiesSubFields,
  onChange,
  selectedTechnologies
}) {
  const { interview } = useInterviewContext();
  const { t } = useTranslation();
  const uniqueId = "accordion-item" + index;
  const [isExpanded, setIsExpanded] = useState(false);
  const [acordionTargetClass, setAcordionTargetClass] = useState("");
  const [buttonclass, setButtonClass] = useState("");
  const _max_Item_per_row = 3;
  let _technologies = [];

  useEffect(() => {
    if (isExpanded) {
      setAcordionTargetClass("show");
      setButtonClass("");
    } else {
      setAcordionTargetClass("");
      setButtonClass("collapsed");
    }
  }, [isExpanded]);

  function resetGroupForRenderifAfterRender() {
    if (_technologies.length >= _max_Item_per_row) _technologies = [];
  }

  function addToGroupForRenderIfNotFull(technology) {
    if (_technologies.length < _max_Item_per_row) {
      _technologies.push(technology);
    }
  }

  function clearGroupForRenderifAfterRender() {
    _technologies = [];
  }

  function toggle() {
    if (isExpanded) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  }

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={uniqueId + "-heading"}>
        <button
          className={"accordion-button " + buttonclass}
          type="button"
          data-bs-target={"#" + uniqueId}
          ariaExpanded="true"
          ariaControls="methodologies"
          onClick={toggle}
        >
          {heading}
        </button>
      </h2>
      <div
        id={uniqueId}
        className={"accordion-collapse collapse " + acordionTargetClass}
        ariaLabelledby="methodologies"
        data-bs-parent="#accordion"
      >
        <div className="accordion-body">
          {technologiesSubFields.map((technologiesSubfield) => {
            clearGroupForRenderifAfterRender();
            return (
              <>
                {technologiesSubfield.description && (
                  <div className="label-wrapper mt-2">
                    <label className="form-label">
                      {t(technologiesSubfield.description)}
                    </label>
                  </div>
                )}
                {technologiesSubfield.description === "" && (
                  <div className="label-wrapper mt-2">
                    <label className="form-label">{""}</label>
                  </div>
                )}
                <div style={{ marginLeft: "20px" }}>
                  {technologiesSubfield.technologies.map(
                    (technology, index) => {
                      resetGroupForRenderifAfterRender();
                      addToGroupForRenderIfNotFull(technology);
                      // render items if groupforrender is full
                      if (_technologies.length === _max_Item_per_row) {
                        return (
                          <div className="tech-skills-content" key={index}>
                            <TechnicalSkillsSectionItemContent
                              technologies={_technologies}
                              onChange={onChange}
                              values={selectedTechnologies}
                              setIsExpanded={setIsExpanded}
                            />
                          </div>
                        );
                      }
                      // render the last  remain items if groupforrender
                      if (
                        technologiesSubfield.technologies.length - 1 ===
                        index
                      ) {
                        return (
                          <div className="tech-skills-content" key={index}>
                            <TechnicalSkillsSectionItemContent
                              technologies={_technologies}
                              values={interview.technologies}
                              onChange={onChange}
                              setIsExpanded={setIsExpanded}
                              selectedTechnologies={selectedTechnologies}
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                  )}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
